(() => {
  const mediaQuery = window.matchMedia('(max-width: 989px)');
  const breadcrumbSection = [...document.querySelectorAll('.shopify-section')].find((section) =>
    section.querySelector('.breadcrumbs__list')
  );
  const mainSection = document.querySelector('product-info')?.closest('.shopify-section');
  const productInfo = document.querySelector('.product__info-container');

  if (!breadcrumbSection || !mainSection || !productInfo) return;

  const placeholder = document.createComment('product-breadcrumbs-placeholder');
  mainSection.parentNode.insertBefore(placeholder, mainSection);

  const colourAnchor =
    (productInfo.id && productInfo.querySelector(`#ProductColourSwatches-${productInfo.id.replace('ProductInfo-', '')}`)) ||
    productInfo.querySelector('.product-form__input--colour-swatch');

  const relocate = () => {
    if (mediaQuery.matches) {
      if (colourAnchor) {
        if (colourAnchor.nextElementSibling !== breadcrumbSection) {
          colourAnchor.insertAdjacentElement('afterend', breadcrumbSection);
        }
      } else if (productInfo.firstElementChild !== breadcrumbSection) {
        productInfo.insertBefore(breadcrumbSection, productInfo.firstElementChild);
      }
      breadcrumbSection.classList.add('product-breadcrumbs--below-media');
      return;
    }

    breadcrumbSection.classList.remove('product-breadcrumbs--below-media');
    if (placeholder.parentNode && placeholder.nextElementSibling !== mainSection) {
      placeholder.before(breadcrumbSection);
    }
  };

  relocate();
  mediaQuery.addEventListener('change', relocate);
})();
